<template>
  <div class="root">
    <div
      class="card"
      v-for="item in lseeonList"
      :key="item.id"
      @click="toClass(item.id)"
    >
        <div class="left">{{ item.start_time }}</div>
        <div class="right">
          <div class="list">
            <div class="weight">{{ item.grade_name }}</div>
            <div>
              上课老师: {{ item.teacher ? item.teacher + "(主教)" : "" }}
              {{ item.teacher_one ? item.teacher_one + "(助教)" : "" }}
            </div>
            <div>上课时间: {{ item.start_time }}</div>
            <div>班级备注: {{ item.lesson }}</div>
          </div>
          <div class="arrived">
            <div>
              <div style="color: green">{{ item.student.length }}</div>
              <div>应到</div>
            </div>
            <div>
              <div style="color: green">{{ item.arrived }}</div>
              <div>已到</div>
            </div>
            <div>
              <div style="color: red">
                {{ item.student.length - item.arrived }}
              </div>
              <div>未到</div>
            </div>
          </div>
        </div>
    </div>
    <div v-if="!lseeonList.length" class="state">无数据</div>
  </div>
</template>

<style scoped>
.card {
  background: #fff;
  margin: 10px 0px;
  height: 180px;
  display: flex;
}

.card .left {
  border-right: 1px solid #eee;
  flex: 2;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card .right {
  flex: 8;
}

.right .list div {
  margin-top: 5px;
  margin-left: 10px;
}

.right .arrived {
  display: flex;
  flex-direction: row;
  border-top: 1px solid #eee;
  margin: 10px 15px;
  justify-content: space-between;
}

.right .arrived > div {
  margin-top: 5px;
}

.weight {
  font-weight: 700;
  font-size: 16px;
}
.state {
  width: 100%;
  padding: 0.4rem 0;
  text-align: center;
  font-size: 0.3rem;
}
</style>

<script>
import { gradeLseeon, getUser } from "@api/user";

export default {
  name: "ClassSgin",
  data: function() {
    return {
      userInfo: {},
      lseeonList: []
    };
  },
  methods: {
    gradeLseeon() {
      var _this = this;
      gradeLseeon(this.userInfo.uid).then(res => {
        var info = Object.values(res.data.info1);

        info.forEach(item => {
          item.student.forEach(stu => {
            if (stu.status == 1) {
              item.arrived++;
            }
          });
        });
        _this.lseeonList = info;
      });
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        this.gradeLseeon(res.data.uid);
      });
    },
    toClass(e) {
      // console.log(e);
      this.$router.push({ path: '/class/student/'+e})
    }
  },
  mounted: function() {
    this.User();
  }
};
</script>
